import { fetch as tomraFetch } from '@tomra/client-side-http-client'
import { keycloak } from './authentication'

const config = {
  fetchNewToken: keycloak.updateToken,
  getToken: () => keycloak.token,
}

export function authenticatedFetch(url: string, options: any) {
  return tomraFetch(url, options, config)
    .run()
    .catch(error => {
      // Logout if refresh token is expired
      if (error.status === 401) {
        keycloak.logout()
      }
      throw error
    })
}
